import React from 'react'
import PropTypes from 'prop-types'
import { _Flex } from './styles'

const Flex = ({
  justify,
  align,
  direction,
  center,
  className,
  noWrap = false,
  wrap = false,
  gap = 0,
  children,
  onClick = () => {},
  onFocus = () => {},
  onHover = () => {},
  onBlur = () => {},
  onMouseLeave = () => {},
  dataTestId = null,
  tabIndex = null,
  ...rest
}) => {
  const extraProps = {}
  const styles = {
    justify,
    align,
    center,
    noWrap,
    direction,
    wrap: wrap ? 1 : undefined,
    gap,
  }
  if(dataTestId) extraProps['data-test-id'] = dataTestId
  if(typeof tabIndex === 'number') extraProps.tabIndex = tabIndex
  return (
    <_Flex
      {...rest}
      {...extraProps}
      {...styles}
      className={className}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      onMouseEnter={onHover}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </_Flex>
  )
}

Flex.propTypes = {
  justify: PropTypes.string,
  align: PropTypes.string,
  direction: PropTypes.string,
  center: PropTypes.bool,
  wrap: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  tabIndex: PropTypes.number,
  noWrap: PropTypes.bool,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseLeave: PropTypes.func,
  gap: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.node]),
}

export default Flex
